import { render } from "./ErrorLicenseStaff.vue?vue&type=template&id=9b8c7410"
import script from "./ErrorLicenseStaff.vue?vue&type=script&lang=js"
export * from "./ErrorLicenseStaff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__